const profesiones = [
    { value: "Alergología", label: "Alergología" },
    { value: "Anatomía Patológica", label: "Anatomía Patológica" },
    { value: "Anestesiología y Reanimación", label: "Anestesiología y Reanimación" },
    { value: "Angiología y Cirugía Vascular", label: "Angiología y Cirugía Vascular" },
    { value: "Audiología", label: "Audiología" },
    { value: "Biología de la Reproducción", label:"Biología de la Reproducción"},
    { value: "Cardiología", label: "Cardiología" },
    { value: "Cardiología Intervencionista", label: "Cardiología Intervencionista" },
    { value: "Cirugía Cardiovascular", label: "Cirugía Cardiovascular" },
    { value: "Cirugía General", label: "Cirugía General" },
    { value: "Cirugía Maxilofacial", label: "Cirugía Maxilofacial" },
    { value: "Cirugía Pediátrica", label: "Cirugía Pediátrica" },
    { value: "Cirugía Plástica, Estética y Reconstructiva", label: "Cirugía Plástica, Estética y Reconstructiva" },
    { value: "Cirugía Torácica", label: "Cirugía Torácica" },
    { value: "Cirugía Vascular", label: "Cirugía Vascular" },
    { value: "Coloproctología", label: "Coloproctología" },
    { value: "Dermatología", label: "Dermatología" },
    { value: "Dermatología Pediátrica", label: "Dermatología Pediátrica" },
    { value: "Endocrinología", label: "Endocrinología" },
    { value: "Endocrinología Pediátrica", label: "Endocrinología Pediátrica" },
    { value: "Endodoncia", label: "Endodoncia" },
    { value: "Epidemiología", label: "Epidemiología" },
    { value: "Gastroenterología", label: "Gastroenterología" },
    { value: "Gastroenterología Pediátrica", label: "Gastroenterología Pediátrica" },
    { value: "Genética Médica", label: "Genética Médica" },
    { value: "Geriatría", label: "Geriatría" },
    { value: "Ginecología y Obstetricia", label: "Ginecología y Obstetricia" },
    { value: "Hematología", label: "Hematología" },
    { value: "Hematología Pediátrica", label: "Hematología Pediátrica" },
    { value: "Hepatología", label: "Hepatología" },
    { value: "Implantología Oral", label: "Implantología Oral" },
    { value: "Infectología", label: "Infectología" },
    { value: "Infectología Pediátrica", label: "Infectología Pediátrica" },
    { value: "Inmunología Clínica", label: "Inmunología Clínica" },
    { value: "Medicina Aeroespacial", label: "Medicina Aeroespacial" },
    { value: "Medicina Crítica", label: "Medicina Crítica" },
    { value: "Medicina de Emergencias", label: "Medicina de Emergencias" },
    { value: "Medicina del Deporte", label: "Medicina del Deporte" },
    { value: "Medicina del Trabajo", label: "Medicina del Trabajo" },
    { value: "Medicina Familiar y Comunitaria", label: "Medicina Familiar y Comunitaria" },
    { value: "Medicina Física y Rehabilitación (Fisiatría)", label: "Medicina Física y Rehabilitación (Fisiatría)" },
    { value: "Medicina Forense", label: "Medicina Forense" },
    { value: "Medicina General", label: "Medicina General" },
    { value: "Medicina Geriátrica", label: "Medicina Geriátrica" },
    { value: "Medicina Hiperbárica", label: "Medicina Hiperbárica" },
    { value: "Medicina Interna", label: "Medicina Interna" },
    { value: "Medicina Legal", label: "Medicina Legal" },
    { value: "Medicina Nuclear", label: "Medicina Nuclear" },
    { value: "Medicina Paliativa", label: "Medicina Paliativa" },
    { value: "Medicina Preventiva", label: "Medicina Preventiva" },
    { value: "Nefrología", label: "Nefrología" },
    { value: "Nefrología Pediátrica", label: "Nefrología Pediátrica" },
    { value: "Neonatología", label: "Neonatología" },
    { value: "Neumología", label: "Neumología" },
    { value: "Neumología Pediátrica", label: "Neumología Pediátrica" },
    { value: "Neurocirugía", label: "Neurocirugía" },
    { value: "Neurofisiología Clínica", label: "Neurofisiología Clínica" },
    { value: "Neurología", label: "Neurología" },
    { value: "Neurología Pediátrica", label: "Neurología Pediátrica" },
    { value: "Nutriología Clínica", label: "Nutriología Clínica" },
    { value: "Obstetricia", label: "Obstetricia" },
    { value: "Odontología Estética", label: "Odontología Estética" },
    { value: "Odontología Forense", label: "Odontología Forense" },
    { value: "Odontología General", label: "Odontología General" },
    { value: "Odontopediatría", label: "Odontopediatría" },
    { value: "Oftalmología", label: "Oftalmología" },
    { value: "Oncología Clínica", label: "Oncología Clínica" },
    { value: "Oncología Médica", label: "Oncología Médica" },
    { value: "Oncología Pediátrica", label: "Oncología Pediátrica" },
    { value: "Oncología Quirúrgica", label: "Oncología Quirúrgica" },
    { value: "Ortopedia y Traumatología", label: "Ortopedia y Traumatología" },
    { value: "Ortodoncia y Ortopedia Maxilar", label: "Ortodoncia y Ortopedia Maxilar" },
    { value: "Otorrinolaringología", label: "Otorrinolaringología" },
    { value: "Patología Bucal y Maxilofacial", label: "Patología Bucal y Maxilofacial" },
    { value: "Pediatría", label: "Pediatría" },
    { value: "Pediatría del Desarrollo", label: "Pediatría del Desarrollo" },
    { value: "Periodoncia", label: "Periodoncia" },
    { value: "Perinatología", label: "Perinatología" },
    { value: "Prostodoncia (Prótesis Dental)", label: "Prostodoncia (Prótesis Dental)" },
    { value: "Psiquiatría", label: "Psiquiatría" },
    { value: "Psiquiatría Infantil y del Adolescente", label: "Psiquiatría Infantil y del Adolescente" },
    { value: "Psicología Clínica", label: "Psicología Clínica" },
    { value: "Radiología Bucal y Maxilofacial", label: "Radiología Bucal y Maxilofacial" },
    { value: "Radiología e Imagen", label: "Radiología e Imagen" },
    { value: "Radiología Intervencionista", label: "Radiología Intervencionista" },
    { value: "Reumatología", label: "Reumatología" },
    { value: "Reumatología Pediátrica", label: "Reumatología Pediátrica" },
    { value: "Sexología Médica", label: "Sexología Médica" },
    { value: "Toxicología Clínica", label: "Toxicología Clínica" },
    { value: "Transplantes", label: "Transplantes" },
    { value: "Urología", label: "Urología" },
    { value: "Urgencias Médico-Quirúrgicas", label: "Urgencias Médico-Quirúrgicas" }
  ];

  export default profesiones;